module.exports = __webpack_public_path__ + "static/media/bck-light.d63c5f70.svg";